<template>
    <div id="aqt_content">
      <div class="content_body">
        <div class="aqt_team">
          <div class="line line1"></div>
          <p class="team_title">强大的阿启泰团队，为您提供多语言数字化+ AI智能+大数据一体化互联网解决方案。</p>
          <img  class="team_img"  src="../../assets/img/index1.png"/>
          <p class="team_content">阿启泰自创立以来，深耕IT领域，为客户打造有竞争力、安全可靠、可落地的产品方案与技术服务。厚积薄发，逐梦同行。</p>
          <ul class="team_nav">
            <router-link to="/Index" active-class="active" class="team_nav_item">
              <li>阿启泰</li>
            </router-link>
            <router-link to="/Server"active-class="active" class="team_nav_item">
              <li>服务</li>
            </router-link>
            <router-link  to="/Case" active-class="active"class="team_nav_item">
              <li>案例展示</li>
            </router-link>

          </ul>
        </div>
        <div class="index_serve">
          <div class="index_serve_info">
            <div class="line2"></div>
            <p class="serve_info_title">阿启泰服务</p>
            <p class="serve_info_content">我们深度对接需求，量身定制专属解决方案，为您的数字化转型全面赋能。</p>
          </div>
          <img  src="../../assets/img/index2.png" class="index2"/>
        </div>
        <div class="server_items">
          <div class="serve_items_title">
            <div class="line3"></div>
            <p class="serve_items_title1"> 阿启泰团队，为您提供</p>
          </div>
          <div class="serve_items">
            <ul class="serve_items_nav" >
              <li class="serve_items_nav1" v-for="(serve,index) in serveArr" :key="index">
                <img :src="serve.img" class="serve_nav_img"/>
                <div class="line4"></div>
                <p class="serve_item1_title">{{serve.serve_item1_title}}</p>
                <p class="serve_item1_content">{{serve.serve_item1_content}}</p>
              </li>

            </ul>

          </div>
        </div>
        <div class="team_info">
<!--          <p class="team_info_title">阿启泰</p>-->
          <div class="team_content">
            <div class="team_content_left">
              <img src="../../assets/img/index9.png" class="team_img"/>
            </div>
            <div class="team_content_right">
              <div class="line5"></div>
              <p class="team_name">阿启泰团队</p>
              <p class="team_describe">阿启泰科技自2016年创立以来，坚守 “感恩、效率、进步、责任” 的核心价值观，以技术创新为核心引擎，深耕智慧图书馆与文化艺术资源数字化建设领域。公司现已拥有25项软件著作权，获评诚信达标企业及多项企业等级认证；先后于2022年、2025年连续通过高新技术企业认定，并在2022年荣获内蒙古自治区工业和信息化厅认定的内蒙古自治区首版次软件产品认定等多项权威资质与荣誉，致力于为客户提供安全、高效、值得信赖的全场景技术服务与数字化解决方案。</p>
            </div>

          </div>
        </div>
        <div class="serve_trade ">
          <div class="line6"></div>
          <p class="serve_trade_title">阿启泰团队服务于各类行业</p>
          <img src="../../assets/img/index15.png" class="serve_trade_img"/>
          <p class=" trade trade1">文化艺术行业</p>
          <p class="trade trade2">政府部门</p>
          <p class="trade trade3">教育行业</p>
          <p class=" trade trade4">医疗行业</p>
          <p class="trade trade5">游戏行业</p>

        </div>
      </div>
    </div>
</template>

<script>
    export default {
      data(){
        return{
          serveArr:[
            {
              img:require('../../assets/img/index3.png'),
              serve_item1_title:'多语言APP /小程序开发',
              serve_item1_content:'一站式多语言应用开发，兼容多端适配、流畅交互与体验'
            },
            {
              img:require('../../assets/img/index4.png'),
              serve_item1_title:'大数据平台建设',
              serve_item1_content:'搭建安全、高效、可扩展的数据中台，实现数据汇聚、治理与价值挖掘'
            },
            {
              img:require('../../assets/img/index5.png'),
              serve_item1_title:'多语言系统架构',
              serve_item1_content:'专业多语言技术架构设计，保障系统稳定、语言切换无感知'
            },
            {
              img:require('../../assets/img/index6.png'),
              serve_item1_title:'多语言数字化建设',
              serve_item1_content:'全链路多语言数字化升级，覆盖内容、服务、管理全流程'
            },
            {
              img:require('../../assets/img/index7.png'),
              serve_item1_title:'多语言网站、公众号二次开发',
              serve_item1_content:'多语言前端优化、功能迭代、体验升级，适配政务/企业/媒体场景'
            },
            {
              img:require('../../assets/img/index8.png'),
              serve_item1_title:'AI智能服务',
              serve_item1_content:'多语言智能检索引擎，支持语义理解、精准匹配、快速定位，大幅提升信息获取效率'
            },
            {
              img:require('../../assets/img/index8.png'),
              serve_item1_title:'AI智慧阅读服务',
              serve_item1_content:'AI 驱动多语言智能解析、语音朗读、内容摘要、重点提取，实现轻量化、高效化阅读'
            },
            {
              img:require('../../assets/img/index8.png'),
              serve_item1_title:'文化艺术大数据服务',
              serve_item1_content:'构建文化艺术大数据体系，提供数据整合、加工、存储、检索与智能应用服务'
            },
          ]
        }
      },
      mounted(){
      }
    }
</script>

<style scoped lang="less">
  #aqt_content{
    padding-bottom: 200px;
   padding-top:70px;
    overflow: hidden;
    .content_body{
      width:70%;
      height:auto;
      margin:0px auto;

      .aqt_team{
        width:100%;
        height:auto;
        .line{
          width:10%;
          height:1px ;
          background-color:#F5A623;
          margin:60px auto;
        }
        .team_title{
          display:inline-block;
          width:100%;
          height:20px;
          font-size:18px;
          color:#F4FAFF;
          text-align:center;
          letter-spacing:3px;
        }
        .team_img{
          width:100%;
          margin-top:10px;
          margin-bottom:50px;
        }
        .team_content{
          display:inline-block;
          width:100%;
          height:20px;
          font-size:15px;
          color:#D3DFFF;
          text-align:center;
          letter-spacing:3px;
        }
        .team_nav{
          width:45%;
          height:30px;
          display:flex;
          flex-direction:row;
          margin:80px auto;
          font-size:14px;
          .team_nav_item{
            width:30%;
            height:100%;
            margin-left:40px;
            border:1px solid #3399ED;
            border-radius:20px;
            text-align:center;
            line-height:30px;
            color:#D3Dfff;
            cursor: pointer;
            &.active{
              color:blue
            }
          }
        }
      }
      .index_serve{
        width:100%;
        height:auto;
        display:flex;
        felx-direction:row;
        .index_serve_info{
          width:100%;
          height:auto;
          .line2{
            width:10%;
            height:1px ;
            background-color:#26BFB9;
            margin-top:5%;
            margin-bottom:5%;
          }
          .serve_info_title{
            font-size:18px;
            color:#F4FAFF;
            letter-spacing: 0.5px;
            margin-bottom:8%;
          }
          .serve_info_content{
            font-size:14px;
            color:#F4FAFF;
          }
        }
        .index2{
          height:240px;

        }
      }
      .server_items{
        width:100%;
        height:auto;
        .serve_items_title{
          width:60%;
          height:80px;
          margin-top: 60px;
          margin-left: 20%;
          margin-bottom: 60px;
          .line3{
            width:10%;
            height:1px ;
            background-color:#F5A623;
            margin:0px auto;
            margin-bottom:30px;
          }
          .serve_items_title1{
            text-align:center;
            font-size:16px;
            color:#F4FAFF;
          }
        }
        .serve_items{
          width:80%;
          height:auto;

          .serve_items_nav{
            width:100%;
            height:100%;
            display:flex;
            flex-direction:row;
            flex-wrap: wrap;
            margin-left:30%;
            .serve_items_nav1{
              width:50%;
              height:auto;
              margin-bottom:30px;
              .serve_nav_img{
                width:20%;
                margin-left:0;
              }
              .line4{
                width:10%;
                height:1px ;
                background-color:#417505;
                margin-top:30px;
                margin-bottom:30px;
              }
              .serve_item1_title{
                font-size:14px;
                color:#D3DFFF;
                margin-bottom:20px;
              }
              .serve_item1_content{
                font-size:12px;
                color:#D3DFFF;
                margin-bottom:20px;
              }
            }
          }

        }
      }
      .team_info{
        width:100%;
        height:auto;
        .team_info_title{
          text-align:center;
          color:purple;
          font-size:16px;
        }
        .team_content{
          width:100%;
          height:300px;
          display:flex;
          flex-direction:row;
          margin-top:30px;
          .team_content_left{
            width:50%;
            .team_img{
              width:70%;
            }
          }
          .team_content_right{
            width:50%;
            height:auto;
            .line5{
              width:10%;
              height:1px ;
              background-color:#3399ED;
              margin-bottom:20px;
            }
            .team_name{
              font-size:16px;
              color:#F4FAFF;
              margin-bottom:40px;
            }
            .team_describe{
              font-size:12px;
              color:#D3DFFF;
              line-height:20px;
              letter-spacing: 2px;
            }
          }
        }
      }
      .serve_trade{
        width:100%;
        height:auto;
        position:relative;
        .line6{
          width:10%;
          height:1px ;
          background-color:#26BFB9;
          margin:100px auto;
          margin-bottom:50px;
        }
        .serve_trade_title{
          font-size:16px;
          color:#F4FAFF;
          text-align:center;
        }
        .serve_trade_img{
          width:100%;
          margin-top:80px;
        }
        .trade{
          position:absolute;
          color:#D3DFFF;
          font-size:12px;
        }
        .trade1{
          left: 47%;
          top: 39%;
        }
        .trade2{
          left: 5%;
          top: 61%;
        }
        .trade3{
          left: 22%;
          top: 100%;
        }
        .trade4{
          left: 71%;
          top: 100%;
        }
        .trade5{
          left:88%;
          top:61%;
        }


      }
    }
  }
</style>
